export const SET_ONLINE_STATUS = 'SET_ONLINE_STATUS';
export const setOnlineStatus = (status) => {
    return {
        type: SET_ONLINE_STATUS,
        status,
    };
};
